import React from 'react'

import '../../Cabecalho/Cabecalho.css'
import crefito from '../../../assets/brasao.png'

export default class Cabecalho extends React.Component {
    renderEstado() {
        if (this.props.valor.uf == 'PB') {
            return (
                <div>
                    <div>Rua Dr. Arnaldo Escorel, 564 - Tambauzinho - João Pessoa/PB</div>
                    <div>CEP: 58042-080 / Telefone: (83) 3021-6900</div>
                    <div>E-mail: crefito1@crefito1.org.br</div>
                </div>
            )
        }
        else if (this.props.valor.uf == 'AL') {
            return (
                <div>
                    <div>Rua Dez de Novembro, 458 - Pitanguinha - Maceió/AL</div>
                    <div>CEP: 57052-220 / Telefone: (82) 3221-0756</div>
                    <div>E-mail: crefito1@crefito1.org.br</div>
                </div>
            )
        }
        else if (this.props.valor.uf == 'RN') {
            return (
                <div>
                    <div>Rua Acarí, 24 - Lagoa Nova - Natal/RN</div>
                    <div>CEP: 59063-280 / Telefone: (84) 3201-0607</div>
                    <div>E-mail: crefito1@crefito1.org.br</div>
                </div>
            )
        }
        else if (this.props.valor.uf == 'PE') {
            return (
                <div>
                    <div>Rua Henrique Dias, 303 - Boa Vista - Recife/PE</div>
                    <div>CEP: 50070-140 / Telefone: (81) 3081-5000</div>
                    <div>E-mail: crefito1@crefito1.org.br</div>
                </div>
            )
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="col-12 mx-auto font-weight-bold">
                    <div className="text-center">
                        <img src={crefito} alt="crefito" className="brasil mt-4" />
                    </div><br /><br />
                    <div>Conselho Regional de Fisioterapia e Terapia Ocupacional da 1ª Região</div>
                    <div>CREFITO-1</div>
                    <div>Circunscrição: AL/PB/PE/RN</div>
                    {this.renderEstado()}
                </div>
            </React.Fragment>
        )
    }
}